import { forwardRef } from 'react';
import { StyledP } from './styled';

const P = forwardRef((props, ref) => <StyledP ref={ref} {...props} />);

export default P;
